import Mutations from '../../odata/mutations';

export default { ...new Mutations('userTarget'), ...new Mutations('userTargets') };
